import script from "./TestProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./TestProfileView.vue?vue&type=script&setup=true&lang=js"

import "./TestProfileView.vue?vue&type=style&index=0&id=edb4b326&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edb4b326"]])

export default __exports__